export enum NaviHealthPathsEnum {
  ROOT = "navihealth",
}

export enum NaviHealthRoutesEnum {
  ROOT = "/navihealth",
}
